<div class="h-100 d-flex flex-column">
    <div class="px-2 flex-fill overflow-hidden">
        <dx-load-panel [position]="{ of: '#treeList' }"
                       [(visible)]="loadingClassificationClasses"
                       [showIndicator]="true"
                       [showPane]="true"
                       [hideOnOutsideClick]="false">
        </dx-load-panel>
        <dx-tree-list id="treeList"
                      class="h-100"
                      [dataSource]="classificationClasses"
                      keyExpr="id"
                      parentIdExpr="parentId"
                      [showRowLines]="false"
                      [showBorders]="false"
                      [allowColumnResizing]="true"
                      [noDataText]="noDataText"
                      (onSelectionChanged)="onClassificationClassSelectionChanged($event)">
            <dxo-editing></dxo-editing>
            <dxo-toolbar>
                <dxi-item location="before">
                    <div *dxTemplate="let data of 'toolbarTemplate'">
                        <dx-button *ngIf="selectedClassificationSystem != undefined && !loadingClassificationClasses && !classificationService.isReadOnlyForUser(selectedClassificationSystem)"
                                   stylingMode="text"
                                   type="default"
                                   text="{{ 'Neue Klasse' | translate }}"
                                   (onClick)="createTopClassificationClass()">
                        </dx-button>
                    </div>
                </dxi-item>
                <dxi-item name="searchPanel"></dxi-item>
            </dxo-toolbar>
            <dxo-scrolling mode="standard" [useNative]="false"></dxo-scrolling>
            <dxo-search-panel [visible]="true" width="250"></dxo-search-panel>
            <dxo-selection mode="single"></dxo-selection>
            <dxi-column dataField="number" caption="{{ 'Id' | translate }}" sortOrder="asc" [width]="150"></dxi-column>
            <dxi-column dataField="name" caption="{{ 'Bezeichnung' | translate }}"></dxi-column>
            <dxi-column type="buttons">
                <dxi-button *ngIf="!classificationService.isReadOnlyForUser(selectedClassificationSystem)"
                            hint="{{ 'Klassifizierungs-Klasse erstellen' | translate }}"
                            stylingMode="text" type="default" icon="plus" [onClick]="createClassificationClass"></dxi-button>
                <dxi-button *ngIf="!classificationService.isReadOnlyForUser(selectedClassificationSystem)"
                            hint="{{ 'Klassifizierungs-Klasse duplizieren' | translate }}"
                            stylingMode="text" type="default" icon="copy" [onClick]="duplicateClassificationClass"></dxi-button>
                <dxi-button *ngIf="!classificationService.isReadOnlyForUser(selectedClassificationSystem)"
                            hint="{{ 'Klassifizierungs-Klasse löschen' | translate }}"
                            stylingMode="text" type="default" icon="trash" [onClick]="deleteClassificationClass"></dxi-button>
            </dxi-column>

        </dx-tree-list>
    </div>
</div>
